export interface AboutUsSection {
  id: string;
  titleKey: string;
  paragraphKeys: string[];
}

export interface AboutUsLink {
  labelKey: string;
  href: string;
}

export const aboutUsSections: AboutUsSection[] = [
  {
    id: "about",
    titleKey: "aboutUs.title",
    paragraphKeys: ["aboutUs.aboutDescription", "aboutUs.aboutDescription2"],
  },
  {
    id: "billing",
    titleKey: "aboutUs.billing",
    paragraphKeys: [
      "aboutUs.billingDescription1",
      "aboutUs.billingDescription2",
    ],
  },
  {
    id: "payments",
    titleKey: "aboutUs.paymentsAndLateFees",
    paragraphKeys: [
      "aboutUs.paymentsDescription1",
      "aboutUs.paymentsDescription2",
      "aboutUs.paymentsDescription3",
    ],
  },
  {
    id: "bay-restoration",
    titleKey: "aboutUs.stateBayRestorationFee",
    paragraphKeys: ["aboutUs.bayFeeDescription1", "aboutUs.bayFeeDescription2"],
  },
  {
    id: "hardship",
    titleKey: "aboutUs.bayFeeHardshipExemption",
    paragraphKeys: [
      "aboutUs.bayFeeHardshipDescription1",
      "aboutUs.bayFeeHardshipDescription2",
    ],
  },
];

export const hardshipLinks: AboutUsLink[] = [
  {
    labelKey: "aboutUs.homeownerApplication",
    href: "/documents/Residential_Income_Based_2026.pdf",
  },
  {
    labelKey: "aboutUs.renterApplication",
    href: "/documents/Renter_Application_Bay_Restoration_2026.pdf",
  },
];

export const externalLinks: AboutUsLink[] = [
  {
    labelKey: "aboutUs.mdeLink",
    href: "http://www.mde.state.md.us/",
  },
];
